import Vue from 'vue';

export const appUpdateState = Vue.observable({ available: false, applying: false, error: '' });
let pendingRegistration = null;

export function notifyAppUpdate(registration) {
  if (!registration || !registration.waiting) return;
  pendingRegistration = registration;
  appUpdateState.available = true;
}

// Only the user's update action may request activation and a page reload.
export function applyAppUpdate() {
  if (!pendingRegistration || appUpdateState.applying) return;
  appUpdateState.applying = true;
  appUpdateState.error = '';
  const workers = navigator.serviceWorker;
  let finished = false;
  let timer;
  const cleanup = () => {
    workers.removeEventListener('controllerchange', reload);
    clearTimeout(timer);
  };
  const reload = () => {
    if (finished) return;
    finished = true;
    cleanup();
    window.location.reload();
  };
  // Another tab may already have activated the waiting worker.
  if (!pendingRegistration.waiting) { reload(); return; }
  workers.addEventListener('controllerchange', reload);
  timer = setTimeout(() => {
    if (finished) return;
    finished = true;
    cleanup();
    appUpdateState.applying = false;
    appUpdateState.error = 'Pembaruan belum aktif. Coba lagi setelah koneksi tersedia.';
  }, 15000);
  try {
    pendingRegistration.waiting.postMessage({ type: 'SKIP_WAITING' });
  } catch {
    finished = true;
    cleanup();
    appUpdateState.applying = false;
    appUpdateState.error = 'Pembaruan belum dapat diterapkan. Silakan coba lagi.';
  }
}
